import React, { Component, useState, useEffect } from "react";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import { netGet } from '../network';

function ProcessOptionsDialog(props) {
    const {
        title = 'Run Draft Options',
        open,
        draft,
        onSave,
        onCancel,
        docName,
        isEdition=false,
        options,
        ...other
    } = props;
    const [revdateValue, setRevdateValue] = React.useState('');
    const [releaseDateValue, setReleaseDateValue] = React.useState('');
    const [htmlValue, setHtmlValue] = React.useState(false);
    const [pdfValue, setPdfValue] = React.useState(true);
    const [partValue, setPartValue] = React.useState('');
    const [sectionValue, setSectionValue] = React.useState('');

    React.useEffect( () => {
        if ( options?.revdate ) {
            setRevdateValue(dayjs(options.revdate));
        } else {
            setRevdateValue(dayjs());
        }
        if ( options?.releaseDate ) {
            setReleaseDateValue(dayjs(options.releaseDate));
        } else {
            setReleaseDateValue(dayjs());
        }
        if ( typeof options?.html === 'boolean' ) {
            setHtmlValue(options.html);
        } else {
            setHtmlValue(false);
        }
        if ( typeof options?.pdf === 'boolean' ) {
            setPdfValue(options.pdf);
        } else {
            setPdfValue(true);
        }
        if ( typeof options?.part === 'string' ) {
            setPartValue(options.part);
        } else {
            setPartValue('');
        }
        if ( typeof options?.section === 'string' ) {
            setSectionValue(options.section);
        } else {
            setSectionValue('');
        }
    }, [open,docName,options]);


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            let outOptions = {
                revdate: revdateValue, 
                releaseDate: releaseDateValue,
                html: htmlValue,
                pdf: pdfValue,
            };
            if ( !isEdition ) {
                outOptions['part'] = partValue;
                outOptions['section'] = sectionValue;
            }
            onSave(outOptions);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const partChanged = (event) => {
        setPartValue(event.target.value);
    }

    const sectionChanged = (event) => {
        setSectionValue(event.target.value);
    }

    const revdateChanged = (newvalue) => {
        setRevdateValue(newvalue);
    }

    const releaseDateChanged = (newvalue) => {
        setReleaseDateValue(newvalue);
    }

    const htmlChanged = (event) => {
        setHtmlValue(event.target.checked)
    }

    const pdfChanged = (event) => {
        setPdfValue(event.target.checked)
    }

    return (
        <Dialog
            maxWidth={'400px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 400,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{width: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 2fr', 
                        justifyItems: 'left', alignItems: 'center', gap: '1ex 1ex'}}>

                    <Box sx={{ display: 'flex', gridColumnStart: 'span 4' }}>
                        <DatePicker label="Revision Date" value={revdateValue}
                            onChange={revdateChanged} sx={{ marginTop: '1ex', marginBottom: '2ex' }} />

                        <DatePicker label="Release Date" value={releaseDateValue}
                            onChange={releaseDateChanged} sx={{ marginTop: '1ex', marginBottom: '2ex', marginLeft: '2ex' }} />
                    </Box>
                    <Box><Typography>Target Formats:</Typography></Box>
                    <Box>
                        <FormControlLabel control={<Checkbox checked={htmlValue}
                                onChange={htmlChanged} />} label="HTML" />
                    </Box>
                    <Box sx={{gridColumnStart: 'span 2'}}>
                        <FormControlLabel control={<Checkbox checked={pdfValue}
                                onChange={pdfChanged} />} label="PDF" />
                    </Box>
                    {!isEdition &&
                        <React.Fragment>
                            <Box sx={{ paddingTop: '2ex' }}><Typography>Filter:</Typography></Box>
                            <Box sx={{ paddingTop: '2ex', gridColumnStart: 'span 2' }}>
                                <TextField label="Part/Volume" value={partValue} onChange={partChanged} size="small" fullWidth
                                />
                            </Box>
                            <Box sx={{ paddingTop: '2ex' }}>
                                <TextField label="Chapter/Section" value={sectionValue} onChange={sectionChanged} size="small" fullWidth
                                />
                            </Box>
                        </React.Fragment>}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function WorkflowCheckinDialog(props) {
    const {
        title,
        open,
        workflowName,
        onSave,
        onCancel,
        workflowIndex,
        ...other
    } = props;
    const [message, setMessage] = React.useState('');


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(message, workflowIndex);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const messageChanged = (event) => {
        setMessage(event.target.value);
    }


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 500,
                        maxHeight: 600,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{paddingTop: '2ex'}}>
                    <TextField label="Checkin message" value={message} onChange={messageChanged} size="small" fullWidth autoFocus={true} 
                        multiline rows={3} />
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} >Checkin</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function WorkflowRevokeCheckoutDialog(props) {
    const {
        title,
        open,
        workflowName,
        onSave,
        onCancel,
        workflowIndex,
        ...other
    } = props;


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(workflowIndex);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 500,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{paddingTop: '2ex'}}>
                    <Typography>All changes since last checkout will be lost.</Typography>
                    <Typography>Do you want to continue?</Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} color="error">Revoke Checkout</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function WorkflowDeleteDialog(props) {
    const {
        title,
        open,
        workflowName,
        onSave,
        onCancel,
        workflowIndex,
        ...other
    } = props;


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(workflowIndex);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 500,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{paddingTop: '2ex'}}>
                    <Typography sx={{display: 'inline'}}>Delete the </Typography><Typography sx={{display: 'inline', fontWeight: 'bold'}}>{workflowName}</Typography><Typography  sx={{display: 'inline'}}> workflow?</Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} color="error">Delete</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );
}


function WorkflowSaveDialog(props) {
    const {
        title,
        open,
        workflowName,
        onSave,
        onDiscard,
        onCancel,
        workflowIndex,
        ...other
    } = props;


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(workflowIndex);
        }
    }

    const onDiscardClick = () => {
        if ( typeof onDiscard === 'function' ) {
            onDiscard(workflowIndex);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 500,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{paddingTop: '2ex'}}>
                    <Typography sx={{display: 'inline'}}>Save the </Typography><Typography sx={{display: 'inline', fontWeight: 'bold'}}>{workflowName}</Typography><Typography  sx={{display: 'inline'}}> workflow?</Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}}>Save</Button>
                <Button variant="outlined" onClick={onDiscardClick} sx={{minWidth: '7em'}} color="error">Discard</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}




function StepDeleteDialog(props) {
    const {
        title,
        open,
        stepName,
        workflowName,
        onSave,
        onCancel,
        stepIndex,
        ...other
    } = props;


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(stepIndex);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };


    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 500,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{paddingTop: '2ex'}}>
                    <Typography sx={{display: 'inline'}}>Delete the </Typography><Typography sx={{display: 'inline', fontWeight: 'bold'}}>{stepName}</Typography>
                    <Typography sx={{display: 'inline'}}> step from </Typography><Typography sx={{display: 'inline', fontWeight: 'bold'}}>{workflowName}</Typography><Typography  sx={{display: 'inline'}}>?</Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} color="error">Delete</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function CreateTemplateWorkflowDialog(props) {
    const {
        title,
        template,
        name,
        open,
        description,
        onSave,
        onCancel,
        templateList,
        editOnly = false,
        ...other
    } = props;

    const [nameValue, setNameValue] = React.useState(null);
    const [descriptionValue, setDescriptionValue] = React.useState(null);
    const [templateValue, setTemplateValue] = React.useState(null);
    const [templateTypeValue, setTemplateTypeValue] = React.useState('MODEL');
    const [nameFocused, setNameFocused] = React.useState(false);
    const [okEnabled, setOkEnabled] = React.useState(false);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    React.useEffect( () => {
        setNameValue(name);
        setDescriptionValue(description);
        setNameFocused(false);
        setOkEnabled(editOnly && name && typeof name == 'string' && name.length > 0);
        if ( Array.isArray(template) && template.length > 0) {
            setTemplateValue(template[0]);
        } else {
            setTemplateValue(template);
        }
    }, [name,description,open,template]);


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(nameValue, descriptionValue, templateValue, templateTypeValue);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const nameChanged = (event) => {
        if ( event.target.value && typeof event.target.value === 'string' && event.target.value.length > 0 ) {
            setOkEnabled(true);
        }
        setNameValue(event.target.value);
    };

    const descriptionChanged = (event) => {
        setDescriptionValue(event.target.value);
    };

    const handleTemplateChange = (event) => {
        if ( templateValue === nameValue ) {
            setNameValue(event.target.value);
        }
        setTemplateValue(event.target.value);
    };

    const handleTemplateTypeChange = (event) => {
        setTemplateTypeValue(event.target.value);
    };

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 500,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent> 
                <Box sx={{paddingTop: '2ex'}}>
                    <TextField label="Name" value={nameValue} onChange={nameChanged} size="small" fullWidth autoFocus={true} 
                        onFocus={event => {
                            event.target.select();
                          }} />
                </Box>
                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" value={descriptionValue} onChange={descriptionChanged} size="small"
                        multiline fullWidth
                        rows={3} />
                </Box>
                {!editOnly &&
                    <React.Fragment>
                        <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                            <Typography sx={{ fontWeight: 'bold', width: '6.2em'}}>Type:</Typography>
                            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                <Select
                                    value={templateTypeValue}
                                    onChange={handleTemplateTypeChange}
                                    sx={{ minWidth: '16em' }}
                                    MenuProps={CreateMenuProps}
                                >
                                    <MenuItem
                                        key="mstt-0"
                                        value="MODEL"
                                    >
                                        Workflow
                                    </MenuItem>
                                    <MenuItem
                                        key="mstt-1"
                                        value="MODEL_SUB"
                                    >
                                        Subworkflow
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                            <Typography sx={{ fontWeight: 'bold', width: '6.2em' }}>Template:</Typography>
                            {Array.isArray(template) ?

                                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                                    <Select
                                        value={templateValue}
                                        onChange={handleTemplateChange}
                                        sx={{ minWidth: '16em' }}
                                        MenuProps={CreateMenuProps}
                                    >
                                        {template.map((sitem, index) => (
                                            <MenuItem
                                                key={'msi-' + index}
                                                value={sitem}

                                            >
                                                {sitem}
                                            </MenuItem>
                                        )
                                        )}
                                    </Select>
                                </FormControl>

                                :

                                <Typography sx={{ paddingLeft: '1em' }}>{template}</Typography>
                            }
                        </Box>
                    </React.Fragment>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} disabled={!okEnabled}>OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}


function CreateStepWorkflowDialog(props) {
    const {
        title,
        template,
        name,
        subroutine,
        form,
        open,
        description,
        onSave,
        onCancel,
        stepList,
        workflowList,
        workflowIndex,
        step,
        editOnly = false,
        ...other
    } = props;

    const [nameValue, setNameValue] = React.useState(null);
    const [descriptionValue, setDescriptionValue] = React.useState(null);
    const [templateValue, setTemplateValue] = React.useState(null);
    const [nameFocused, setNameFocused] = React.useState(false);
    const [subroutines, setSubroutines] = React.useState([]);
    const [subroutineValue, setSubroutineValue] = React.useState('');
    const [forms, setForms] = React.useState([]);
    const [formValue, setFormValue] = React.useState('');
    const [okEnabled, setOkEnabled] = React.useState(false);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    React.useEffect( () => {
        const sub = subroutine ? subroutine : '';
        const fm =  form ? form : sub;
        setNameValue(name);
        setDescriptionValue(description);
        setSubroutineValue(sub);
        setFormValue(fm);
        const tv = Array.isArray(template) ? template[0] : template;
        setTemplateValue(tv);
        setNameFocused(false);
        setOkEnabled(isValid(name, sub, fm, tv));
        // console.log('Subroutine: ' +subroutine);
    }, [name,description,open,template,subroutine,form]);

    React.useEffect(() => {
        if (open) {
            /*
            netGet('/api/workflow/def/list?categ=SUBS')
                .then(response => response.json())
                .then(data => {
                    if (data && Array.isArray(data)) {
                        // console.log('Subroutine Definitions: ' + data.length);
                        setSubroutines(data.sort( (a,b) => a.label.localeCompare(b.label)));
                    }
                }).catch(error => {
                    console.log(`Error fetching subroutines: ${error}`);
                });
            */
            loadForms();
        }
        if ( open && Array.isArray(workflowList) && workflowIndex >= 0 ) {
            const sl = [...workflowList];
            // remove ourselves
            sl.splice(workflowIndex,1);
            setSubroutines(sl.sort( (a,b) => a.label.localeCompare(b.label)));
        }
    }, [open, workflowList, workflowIndex]);

    const loadForms = () => {
        netGet('/api/workflow/form/list')
            .then(response => response.json())
            .then(data => {
                if (data && Array.isArray(data)) {
                    // console.log('Forms: ' + data.length);
                    setForms(data.sort( (a,b) => a.label.localeCompare(b.label)));
                    
                }
            });
    };


    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            onSave(nameValue, descriptionValue, templateValue, templateValue === 'FORM' ? formValue : subroutineValue);
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const isValid = (n, s, f, t=templateValue) => {
        let r = true;
        if ( t === 'CALL' && !s) {
            r = false;
        } else if ( t === 'FORM' && !f) {
            r = false;
        }
        const rr =  r && n && n.length > 0;
        // console.log(' t: ' + templateValue + ' n: ' + n + ' s: ' + s + ' f:' + f + ' => ' + r + ',' + rr);
        return rr;
    };

    const nameChanged = (event) => {
        setNameValue(event.target.value);
        setOkEnabled(isValid(event.target.value, subroutineValue, formValue));
    };

    const descriptionChanged = (event) => {
        setDescriptionValue(event.target.value);
        setOkEnabled(isValid(nameValue, subroutineValue, formValue));
    };

    const handleTemplateChange = (event) => {
        /*
        if ( templateValue === nameValue ) {
            setNameValue(event.target.value);
            setOkEnabled(isValid(event.target.value, subroutineValue, formValue, event.target.value));
        } else {
            setOkEnabled(isValid(nameValue, subroutineValue, formValue, event.target.value));
        }
        */
        setOkEnabled(isValid(nameValue, subroutineValue, formValue, event.target.value));
        setTemplateValue(event.target.value);
    };

    const handleSubroutineChange = (event) => {
        setSubroutineValue(event.target.value);
        const sub = subroutines.find( item => item.name === event.target.value);
        let nv = nameValue;
        if ( sub && (typeof nameValue === 'undefined' || nameValue === '') ) {
            setNameValue(sub.label);
            nv = sub.label;
        }
        setOkEnabled(isValid(nv, event.target.value, formValue));
    };

    const handleFormChange = (event) => {
        setFormValue(event.target.value);
        const f = forms.find( item => item.name === event.target.value);
        let nv = nameValue;
        if ( f && (typeof nameValue === 'undefined' || nameValue === '')) {
            setNameValue(f.label);
            nv = f.label;
        }
        const v = isValid(nv, subroutineValue, event.target.value);
        // console.log('Form valid: ' + v);
        setOkEnabled(v);
    };

    const getTemplateLabel = (tvalue) => {
        const step = stepList.find( item => item.name === tvalue);
        if ( step ) {
            return step.label;
        }
        return tvalue;
    };

    /*
{Array.isArray(stepList) && editOnly ?

:

                        <Typography sx={{ paddingLeft: '1em', fontWeight: 'bold' }}>{getTemplateLabel(templateValue)}</Typography>
    */

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                  minWidth: 500,
                  maxHeight: 600
                }
              }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent> 
                <Box sx={{paddingTop: '2ex'}}>
                    <TextField label="Name" value={nameValue} onChange={nameChanged} size="small" fullWidth autoFocus={true} 
                        onFocus={event => {
                            event.target.select();
                          }} />
                </Box>
                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" value={descriptionValue} onChange={descriptionChanged} size="small"
                        multiline fullWidth
                        rows={3} />
                </Box>
                <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                    <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Step Type:</Typography>

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <Select
                            value={templateValue}
                            onChange={handleTemplateChange}
                            sx={{ minWidth: '16em' }}
                            MenuProps={CreateMenuProps}
                        >
                            {stepList.map((sitem, index) => (
                                <MenuItem
                                    key={'msi-' + index}
                                    value={sitem.name}

                                >
                                    {sitem.label}
                                </MenuItem>
                            )
                            )}
                        </Select>
                    </FormControl>

                </Box>
                {templateValue === 'CALL' &&
                    <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Subworkflows:</Typography>
                        {Array.isArray(subroutines) ?

                            <FormControl sx={{ m: 1, minWidth: 120, width: '100%' }} size="small">
                                <Select
                                    value={subroutineValue}
                                    onChange={handleSubroutineChange}
                                    sx={{ minWidth: '16em' }}
                                    MenuProps={CreateMenuProps}
                                >
                                    {subroutines.map((sitem, index) => (
                                        <MenuItem
                                            key={'msiv-' + index}
                                            value={sitem.name}

                                        >
                                            {sitem.label}
                                        </MenuItem>
                                    )
                                    )}
                                </Select>
                            </FormControl>

                            :

                            <Typography sx={{ paddingLeft: '1em' }}>{subroutines}</Typography>
                        }
                    </Box>
                }
                {templateValue === 'FORM' &&
                    <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '7em' }}>Form:</Typography>
                        {Array.isArray(forms) ?

                            <FormControl sx={{ m: 1, minWidth: 120, width: '100%' }} size="small">
                                <Select
                                    value={formValue}
                                    onChange={handleFormChange}
                                    sx={{ minWidth: '16em' }}
                                    MenuProps={CreateMenuProps}
                                >
                                    {forms.map((sitem, index) => (
                                        <MenuItem
                                            key={'mfiv-' + index}
                                            value={sitem.name}

                                        >
                                            {sitem.label}
                                        </MenuItem>
                                    )
                                    )}
                                </Select>
                            </FormControl>

                            :

                            <Typography sx={{ paddingLeft: '1em' }}>{forms}</Typography>
                        }
                    </Box>
                }
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} disabled={!okEnabled}>OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}


function CreateWorkflowDialog(props) {
    const {
        title,
        template,
        name,
        type,
        categ,
        document,
        open,
        documentList,
        description,
        onSave,
        onCancel,
        editOnly = false,
        ...other
    } = props;

    const [nameValue, setNameValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const [templateValue, setTemplateValue] = useState(null);
    const [categValue, setCategValue] = useState('DEF');
    const [typeValue, setTypeValue] = useState('custom');
    const [nameFocused, setNameFocused] = useState(false);
    const [docList, setDocList] = React.useState([]);
    const [docValue, setDocValue] = React.useState('__NONE__');

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const CreateMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const TypeMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 160,
            },
        },
    };

    const DocMenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                minWidth: 300,
            },
        },
    };

    React.useEffect( () => {
        setNameValue(name);
        setDescriptionValue(description);
        if ( Array.isArray(template) ) {
            setTemplateValue(template[0]);
        } else {
            setTemplateValue(template);
        }
        setNameFocused(false);
        if ( typeof categ === 'string' ) {
            setCategValue(categ);
        } else {
            setCategValue('DEF');
        }
        if ( typeof type === 'string') {
            setTypeValue(type);
        } else {
            setTypeValue('custom');
            setDocValue('__NONE__');
        }
        if ( typeof document === 'string' && document !== '' ) {
            setDocValue(document);
            setTypeValue('doc');
        } else {
            setDocValue('__NONE__');
            setTypeValue('custom');
        }
    }, [name,description,type,open,template,document, categ]);

    React.useEffect( () => {
        /*
        netGet('/api/doc/roots?sort=alpha')
            .then(response => response.json())
            .then(docs => {
                if ( Array.isArray(docs) ) {
                    setDocList(docs);
                    setDocValue(docs.length > 0 ? docs[0].id : '');
                }
            }).catch ( error => {
                console.log('Error fetching profiles: ' + error);
            });
        */
        if (Array.isArray(documentList)) {
            const dl = [ ...documentList];
            dl.splice(0, 0, {id: '__NONE__', title: 'None'});
            setDocList(dl);
            setDocValue('__NONE__');
        }
    },[documentList]);

    const onOKClick = () => {
        if ( typeof onSave === 'function' ) {
            const doc = docList.find ( item => item.id === docValue);
            onSave( {
                name: nameValue,
                description: descriptionValue,
                template: templateValue,
                category: categValue,
                type: typeValue,
                document: docValue,
                documentTitle: doc ? doc.title : null,
            });
        }
    }

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if ( typeof onCancel === 'function' ) {
            onCancel();
        }
    };

    const nameChanged = (event) => {
        setNameValue(event.target.value);
    };

    const descriptionChanged = (event) => {
        setDescriptionValue(event.target.value);
    };

    const handleTemplateChange = (event) => {
        setTemplateValue(event.target.value);
    };

    const handleTypeChange = (event) => {
        setTypeValue(event.target.value);
    };

    const handleCategChange = (event) => {
        setCategValue(event.target.value);
    };


    const handleDocChange = (event) => {
        const docId = event.target.value;
        setDocValue(docId);

        const doc = docList.find ( item => item.id === docId);
        if ( doc && (typeof nameValue === 'undefined' || nameValue === '')) {
            setNameValue(doc.title);
        }
    }

    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 1000,
                        maxWidth: 1200,
                        maxHeight: 750,
                        minHeight: 700,
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{ paddingTop: '2ex' }}>
                    <TextField label="Name" value={nameValue} onChange={nameChanged} size="small" fullWidth
                        />
                </Box>
                <Box sx={{paddingTop: '3ex'}}>
                    <TextField label="Description" value={descriptionValue} onChange={descriptionChanged} size="small"
                        multiline fullWidth
                        rows={13} />
                </Box>
                <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center', justifyContent: 'space-between' }}>
                    {/* 
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '6em' }}>Type:</Typography>
                        <FormControl sx={{ m: 1, minWidth: 120, marginLeft: 0 }} size="small">
                            <Select
                                value={categValue}
                                onChange={handleCategChange}
                                sx={{ minWidth: '160px' }}
                                MenuProps={TypeMenuProps}
                            >
                                <MenuItem key='cft-def'
                                    value='DEF'>
                                    Workflow
                                </MenuItem>
                                <MenuItem key='cft-sub'
                                    value='DEF_SUB'>
                                    Subworkflow
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', minWidth: '6em' }}>Document:</Typography>
                        <FormControl sx={{ m: 1, width: '400px', minWidth: '350px', marginLeft: 0 }} size="small">
                            <Select
                                value={docValue}
                                onChange={handleDocChange}
                                sx={{ minWidth: '350px', width: '400px', }}
                                MenuProps={DocMenuProps}
                            >
                                {
                                    docList.map(doc =>
                                        (<MenuItem key={doc.id} value={doc.id}>{doc.title}</MenuItem>)
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Box>
                    
                </Box>
                {!editOnly &&
                    <Box sx={{ display: 'flex', paddingTop: '2em', alignItems: 'center' }}>
                        <Typography sx={{ fontWeight: 'bold', width: '5.5em' }}>Template:</Typography>
                        {Array.isArray(template) ?

                            <FormControl sx={{ m: 1, minWidth: '350px', width: '400px' }} size="small">
                                <Select
                                    value={templateValue}
                                    onChange={handleTemplateChange}
                                    sx={{ minWidth: '350px', width: '400px' }}
                                    MenuProps={CreateMenuProps}
                                >
                                    {template.map((templateName) => (
                                        <MenuItem
                                            key={'cswd' + templateName}
                                            value={templateName}
                                        >
                                            {templateName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            :

                            <Typography sx={{ paddingLeft: '1em' }}>{template}</Typography>
                        }
                    </Box>
                }
            </DialogContent>
            <DialogActions sx={{padding: 3}}>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}}>OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{minWidth: '7em'}}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

export { WorkflowCheckinDialog, WorkflowRevokeCheckoutDialog, WorkflowDeleteDialog, WorkflowSaveDialog, 
    StepDeleteDialog, CreateStepWorkflowDialog, CreateTemplateWorkflowDialog, CreateWorkflowDialog, ProcessOptionsDialog };